import { createAction } from 'typesafe-actions';
import { ACTIONS, TableLimitsType } from './types';

export const saveTableSettingsToStoreAction = createAction(ACTIONS.SAVE_TABLE_SETTINGS_TO_STORE)<{
  tableId: string;
  tableName: string;
  gameId: string | null;
  dealerNickname: string;
  minBetLimit: number;
  maxBetLimit: number;
  displayingWinResult: number;
  tableLimits: TableLimitsType;
}>();

export const updateGameIdAction = createAction(ACTIONS.UPDATE_GAME_ID)<{ gameId: string }>();

export const updateDealerAction = createAction(ACTIONS.UPDATE_DEALER)<{ dealerNickname: string }>();
